import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  href: string;
}
export function ServiceCard({
  title,
  description,
  icon,
  href
}: ServiceCardProps) {
  return <Link to={href} className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-8 flex flex-col h-full" data-id="element-271">
      <div className="flex items-center gap-3 mb-4" data-id="element-272">
        <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-accent transition-all duration-300 group-hover:scale-110 group-hover:rotate-6 group-hover:shadow-md" data-id="element-273">
          <div className="transition-transform duration-300 group-hover:scale-110" data-id="element-274">
            {icon}
          </div>
        </div>
        <h3 className="text-xl font-serif font-bold text-gray-900 group-hover:text-primary transition-colors" data-id="element-275">
          {title}
        </h3>
      </div>

      <p className="text-gray-600 leading-relaxed mb-6 flex-grow text-[14px]" data-id="element-276">
        {description}
      </p>

      <div className="flex items-center text-primary font-medium group-hover:text-accent transition-colors" data-id="element-277">
        <span data-id="element-278">Learn More</span>
        <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-279" />
      </div>
    </Link>;
}